<template>
    <div>
        <div id="hello-hello">

            <p style="display:inline;float: left;line-height: 22px;"><b>-出库资料列表</b></p>

            <!-- <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待排</el-radio-button>
                    <el-radio-button label="1">已排</el-radio-button>
                    <el-radio-button label="2">生产</el-radio-button>
                    <el-radio-button label="3">暂停</el-radio-button>
                    <el-radio-button label="4">产中停</el-radio-button>
                    <el-radio-button label="5">返工</el-radio-button>
                    <el-radio-button label="6">完成</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div> -->

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入产品名称/客户" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                <el-button round @click="batchDelete">删除</el-button>
            </p> -->

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                <el-button round @click="exportExcel">导出</el-button>
                <span>-</span>
            </p> -->

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="download">下载模板</el-button>
                <span>-</span>
            </p> -->

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                    <el-button round type="primary">批量导入</el-button>
                    <span>-</span>
                </el-upload>
            </p> -->

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDialog">新增</el-button>
                <span>-</span>
            </p>

        </div>

        <el-table :data="shipmentBaseList" style="width: 2000px;" ref="plasticTable" highlight-current-row
            v-loading="loading" :element-loading-text="loadingText" @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="45">
            </el-table-column>

            <el-table-column prop="productName" label="产品名称" width="350">
            </el-table-column>
            <el-table-column prop="customer" label="客户" width="200">
            </el-table-column>

            <el-table-column prop="customerProductName" label="客户品名" width="350">
            </el-table-column>

            <el-table-column prop="specifications" label="客户规格" width="400">
            </el-table-column>

            <!-- <el-table-column prop="createdTime" label="创建日期" width="100">
            </el-table-column> -->

            <el-table-column fixed="right" label="操作" width="170">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="出库资料详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">

                            <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                                :remote-method="searchProduct" :loading="loading" style="width:370px"
                                :disabled="modifyDisable">
                                <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="客户" required :label-width="formLabelWidth" prop="customerAbbrev">

                            <el-select v-model="form.customerAbbrev" filterable remote reserve-keyword
                                placeholder="请输入关键字" :remote-method="searchCustomer" :loading="loading"
                                @change="cusChange" style="width:370px" :disabled="modifyDisable">
                                <el-option v-for="item in form.customerList" :key="item.value"
                                    :label="item.customerAbbrev" :value="item.customerId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="客户品名" :label-width="formLabelWidth">
                            <el-input v-model="form.customerProductName" autocomplete="off" type="textarea"
                                style="width:370px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="客户规格" :label-width="formLabelWidth">
                            <el-input v-model="form.specifications" autocomplete="off" type="textarea"
                                style="width:370px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div style="width:350px;display: inline-block;"></div>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addShipmentBase('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "OutStockBase",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            shipmentBaseList: [],
            dlgFormVisible: false,

            statusSearch: 0,

            queryValue: '',
            form: {
                id: '',

                customerList: [],
                customerId: '',
                customerAbbrev: '',

                productList: [],
                productId: '',
                productName: '',

                customerProductName: '',
                specifications: ''
            },
            loading: false,
            modifyDisable: false,

            spendTime: 0,
            timer: null,

            formLabelWidth: '120px',

            multipleSelection: [],

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0,

            rules: {
                customerAbbrev: [
                    { required: true, message: '请选择客户', trigger: 'blur' },
                    { required: true, message: '请选择客户', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 动态生成loading上显示的文字
        loadingText() {
            return `加载中，用时 ${this.spendTime} 秒`;
        }
    },
    methods: {
        handleSelectionChange(val) {
            // console.log('val')
            // console.log(val)
            this.multipleSelection = val
        },
        batchDelete() {

            var rows = this.multipleSelection

            if (rows) {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    rows.forEach(row => {

                        this.removePlasticOrder(row)
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })

            }

        },
        exportExcel() {

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/excel",
                data: {
                    userId: this.userId,
                    statusStr: this.statusSearch,
                    queryParam: this.queryValue,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "订单导出.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        uploadFile(f) {
            this.loading = true
            this.spendTime = 0

            this.timer = setInterval(() => {

                this.spendTime += 1
            }, 1000)

            const form = new FormData()

            form.append('uploadFile', f.file)

            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg,
                    duration: 0,
                    showClose: true
                })

                if (data.status != 200) {

                    this.loading = false

                    clearInterval(this.timer)
                    this.timer = null
                    return
                }

                this.getAllBaseOutStock(this.statusSearch)
            })
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/plastic/order/download",
                data: {},
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "订单导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        searchOrder(query) {
            this.shipmentBaseList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.getAllBaseOutStock(this.statusSearch)
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        getBaseProductAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: val,
                    status: 1,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data
            })
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false
                    this.getBaseProductAll(val)
                }, 200)

            }

        },
        handleClick(row) {

            this.modifyDisable = true

            this.form.id = row.id

            this.form.customerAbbrev = row.customerId
            this.form.customerId = row.customerId

            this.form.productName = row.productName
            this.form.productId = row.productId

            this.form.customerProductName = row.customerProductName
            this.form.specifications = row.specifications

            this.dlgFormVisible = true
        },
        openDialog() {

            this.modifyDisable = false

            this.form.id = ''

            this.form.productName = ''
            this.form.customerAbbrev = ''

            this.form.customerProductName = ''
            this.form.specifications = ''

            this.dlgFormVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removePlasticOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        getBaseCustomerAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getAll",
                data: {
                    queryParam: val,
                    typeStr: '1',
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.customerList = data.data
            })
        },
        searchCustomer(val) {

            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getBaseCustomerAll(val)
                }, 200)

            }
        },
        cusChange(value) {
            // console.log(value)

            this.form.customerId = value
        },

        addShipmentBase(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios({
                        method: "post",
                        url: "/shiro/base/shipment/add",
                        data: {
                            id: this.form.id,

                            productName: this.form.productName,
                            customer: this.form.customerAbbrev,

                            customerProductName: this.form.customerProductName,
                            specifications: this.form.specifications,

                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dlgFormVisible = false

                        this.getAllBaseOutStock(this.statusSearch)
                    })
                } else {
                    return false
                }
            })
        },
        searchByStatus(val) {
            this.pageIndex = 0

            this.getAllBaseOutStock(val)
        },
        removePlasticOrder(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/plastic/order/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllBaseOutStock(this.statusSearch)
            })
        },
        getAllBaseOutStock(val) {

            this.loading = true

            const formData = new FormData()


            formData.append('queryParam', this.queryValue)

            formData.append('companyId', this.companyId)

            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/base/shipment/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.shipmentBaseList = data.data

                this.total = this.shipmentBaseList.length > 0 ? this.shipmentBaseList[0].total : 0

                this.loading = false
            })
        },
        pageClick(currentPage) {
            this.shipmentBaseList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllOrder(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllOrder(this.statusSearch)
        },
    },
    mounted() {
        // console.log('PlasticOrder.vue--mounted()')

        this.setDefaultPath('/outStockBase')

        this.getAllBaseOutStock(this.statusSearch)

        this.getBaseCustomerAll("")

    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.el-pagination__total {
    color: green;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

.el-radio input[aria-hidden="true"] {
    display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>